import React, {FC, useState} from 'react';

import {ModifyCardGroupsDropdownTypesEnum} from '../../../../../../../../../../src/components/common/dropdowns/cardGroups/modifyCardGroupDropdown';
import {Trans} from '../../../../../../../../../shared/helpers/src/internationalization/react';
import {RendererOf} from '../../../../../../../../../shared/helpers/src/react/reactHelpers';
import {SimpleDropdown} from '../../../../../../../../../shared/ui/src/components/dropdowns/simpleDropdown';
import {SimpleDropdownItem} from '../../../../../../../../../shared/ui/src/components/dropdowns/simpleDropdownItem';
import {PopoverTransferProps} from '../../../../../../../../../shared/ui/src/components/popovers/popoverCoordinator';
import {RenderCardGroupDropdownOptions} from './contactsTableMultiListsChevronAction';

/*
 * Constants.
 */

const listsDropdownWidth = 160; // px.

/*
 * Props.
 */

interface ContactsTableMultiListsChevronDropdownProps {
  popoverProps: PopoverTransferProps;
  renderCardGroupDropdown: RendererOf<RenderCardGroupDropdownOptions>;
}

/*
 * Component.
 */

export const ContactsTableMultiListsChevronDropdown: FC<ContactsTableMultiListsChevronDropdownProps> = (
  props,
) => {
  const {popoverProps, renderCardGroupDropdown} = props;
  const [isShowingCardGroupsDropdown, setIsShowingCardGroupsDropdown] = useState(false);
  const [dropdownModifyGroupsType, setDropdownModifyGroupsType] = useState(
    ModifyCardGroupsDropdownTypesEnum.ADD,
  );

  const onDropdownItemSelect = (type: ModifyCardGroupsDropdownTypesEnum) => {
    setDropdownModifyGroupsType(type);
    setIsShowingCardGroupsDropdown(true);
  };

  if (isShowingCardGroupsDropdown) {
    return (
      <>
        {renderCardGroupDropdown({
          popoverProps,
          type: dropdownModifyGroupsType,
        })}
      </>
    );
  }

  return (
    <SimpleDropdown {...popoverProps} width={listsDropdownWidth}>
      <SimpleDropdownItem
        onSelect={(event) => {
          event.preventDefault();
          onDropdownItemSelect(ModifyCardGroupsDropdownTypesEnum.ADD);
        }}
      >
        <Trans id="contact-manager-table-multi-select-actions-dropdown-add-to-lists">Add to lists</Trans>
      </SimpleDropdownItem>
      <SimpleDropdownItem
        onSelect={(event) => {
          event.preventDefault();
          onDropdownItemSelect(ModifyCardGroupsDropdownTypesEnum.REMOVE);
        }}
      >
        <Trans id="contact-manager-table-multi-select-actions-dropdown-remove-to-lists">
          Remove from lists
        </Trans>
      </SimpleDropdownItem>
    </SimpleDropdown>
  );
};
